import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { withMaintenanceCheck } from '@/hocs';
import { makeSelectProcessingStatus } from '@/model/invoice/selectors';
import { InvoiceProcessingStatus, InvoiceUIState } from '@/model/invoice/types';
import { withInvoiceInitialization } from '@/pages/invoice/hocs';
import { BankPage, BanksPage, DetailsPage, InactiveProcessingStatusPage } from '@/pages/invoice/pages';

const selectStatus = makeSelectProcessingStatus();

const withRoutesValidation = (Component: React.FunctionComponent | React.ComponentClass, basePath: string) => (
  props: { [k in string]: unknown },
): JSX.Element => {
  const { pathname } = useLocation();
  const status = useSelector(selectStatus);
  if (
    // prettier-ignore
    // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
    status
    && status !== InvoiceProcessingStatus.IN_PROGRESS
    && status !== InvoiceProcessingStatus.EXPIRED
    && !pathname.endsWith(InvoiceUIState.STATUS)
  ) {
    return <Redirect to={`${basePath}/${InvoiceUIState.STATUS}`} />;
  }
  if (
    // prettier-ignore
    // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
    (status === InvoiceProcessingStatus.IN_PROGRESS || status === InvoiceProcessingStatus.EXPIRED)
    && pathname.endsWith(InvoiceUIState.STATUS)
  ) {
    return <Redirect to={`${basePath}/${InvoiceUIState.DETAILS}`} />;
  }
  return <Component {...props} />;
};

const DefaultRoute: React.FC<RouteComponentProps> = ({ location, match: { path } }: RouteComponentProps) => {
  console.warn(`URL not found: ${location.pathname}`);
  return <Redirect to={`${path}/${InvoiceUIState.DETAILS}`} />;
};

export const InvoicePages: React.FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route
        path={`${path}/${InvoiceUIState.STATUS}`}
        component={withRoutesValidation(InactiveProcessingStatusPage, path)}
      />
      <Route path={`${path}/${InvoiceUIState.DETAILS}`} component={withRoutesValidation(DetailsPage, path)} />
      <Route path={`${path}/${InvoiceUIState.BANKS}`} component={withRoutesValidation(BanksPage, path)} />
      <Route path={`${path}/${InvoiceUIState.BANK}/*`} component={withRoutesValidation(BankPage, path)} />
      <Route component={DefaultRoute} />
    </Switch>
  );
};

export default withMaintenanceCheck('invoiceDisabled')(withInvoiceInitialization(InvoicePages));
